<template>
  <div>
    <ModalEdit v-bind="{ pageId }" />
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import ModalEdit from '@/components/Pages/ModalEdit.vue';

export default {
  name: 'PageEdit',
  components: {
    ModalEdit,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  beforeRouteEnter: middleware('account-permission:edit pages'),
};
</script>
